import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';
import { createRoot } from 'react-dom/client';
import {
    createFetchProductApiHandler,
    createSelectFilterHandler
} from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/selectFilter';
import * as React from 'react';
import { getSelectedConcretes } from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/variantMap';
import {
    MdcSelectSelection
} from 'PyzShopUi/scripts/product-detail-page/components/VarriantSelection/MdcSelectSelection';
import {
    AttributeSelection
} from 'PyzShopUi/scripts/product-detail-page/components/VarriantSelection/AttributeSelection';
import { IProductFilter, IVariantFilter, VariantMap } from 'PyzShopUi/scripts/product-detail-page/interfaces';
import { redirectToConcrete } from 'PyzShopUi/scripts/product-detail-page/includes/redirectToConcrete';
import buildProductFilterComponent
    from 'PyzShopUi/scripts/product-detail-page/includes/product-configurator/includes/productFilterComponentBuilder';
import {} from 'PyzShopUi/scripts/product-detail-page/hoc/withProductFilter'
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';

export default class ProductFilterWidget {
    private static productFilterElementRoot;
    public static init = (articleMainInfoElement: HTMLElement, initProductInfoFunction: () => void): void => {
        const productFilterElement: HTMLElement = articleMainInfoElement.querySelector('div [data-spryker-product-filter="true"]');
        if (!productFilterElement) {
            return;
        }

        if (!this.productFilterElementRoot) {
            this.productFilterElementRoot = createRoot(productFilterElement);
        }

        const apiUrl: string = productFilterElement.dataset.apiUrl;
        const fetchProductFunction = createFetchProductApiHandler(apiUrl);
        const filterData: IProductFilter[] = JSON.parse(productFilterElement.dataset.filter);
        const variantMap: VariantMap = JSON.parse(productFilterElement.dataset.variants);
        const activeConcreteId: string = productFilterElement.dataset.concreteId;
        const preselectedFilters: any = variantMap[activeConcreteId];
        const filters: IVariantFilter[] = buildProductFilterComponent(filterData, preselectedFilters);
        const currentlySelectedConcretes = getSelectedConcretes(filters, variantMap);
        const addToCartFormElement: HTMLFormElement = articleMainInfoElement.querySelector('add-to-cart-form');
        const selectFilterHandler = createSelectFilterHandler(addToCartFormElement);

        if (activeConcreteId) {
            selectFilterHandler(currentlySelectedConcretes);
            initProductInfoFunction();
        }

        if (!filters.length) {
            const variantNames = ProductVariantDataHandler.getArticleAllVariants();
            this.productFilterElementRoot.render(
                <React.Suspense fallback={<Loading />}>
                    <MdcSelectSelection
                        onSelectConcrete={(concreteId) => {
                            // since there are some difficulties with updating the swiper, we redirect
                            // to the concrete product page if the variant is changed via dropdown
                            // this may change with https://jira.louis.de/browse/SX-1539
                            redirectToConcrete(concreteId);
                        }}
                        onSelectFilter={selectFilterHandler}
                        activeConcreteId={activeConcreteId}
                        variantMap={variantMap}
                        variantNames={variantNames}
                    />
                </React.Suspense>
            );
        } else {


            this.productFilterElementRoot.render(
                <React.Suspense fallback={<Loading />}>
                    <AttributeSelection
                        onSelectConcrete={(concreteId) => {
                            redirectToConcrete(concreteId);
                        }
                        }
                        onSelectFilter={selectFilterHandler}
                        filters={filters}
                        variantMap={variantMap}
                    />
                </React.Suspense>

            );
        }
    };
}
